import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import {
  $errorV2,
  $verificationRequestV2,
  verificationRequestMountedV2,
} from './model'

export const useVerificationRequestV2 = () => {
  const { pathname } = useLocation()
  const verificationRequest = useStore($verificationRequestV2)
  const error = useStore($errorV2)

  React.useEffect(() => {
    verificationRequestMountedV2()
  }, [pathname])

  return { verificationRequest, error }
}
